// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-text_root__iFwXL"};